import React from "react"

interface PortfolioConfirmationProps {
}

export const PortfoilioConfirmation: React.FC<PortfolioConfirmationProps> = () => {
    return <div className="leadcapturelp-confirmation-other">
        <h1 className="leadcapturelp-confirmation-other-title">Thanks, we’ll be in touch shortly.</h1>
        <div className="leadcapturelp-confirmation-other-body">
            <div className="leadcapturelp-confirmation-other-body-caption">WHILE YOU WAIT...</div>
            <div className="leadcapturelp-confirmation-other-body-title">Calculate your savings potential with Portfolio Manager AI.</div>
            <div className="leadcapturelp-confirmation-other-body-actions">
                <a href="/portfolio-manager-ai" className="btn btn-sm btn-primary-on-dark">Run Free Analysis</a>
            </div>
        </div>
    </div>
}